import { defineStore } from 'pinia'
import baseService from '@/utils/http/axios'

export interface MaterialItem {
  id: string | number
  materialName: string
  storeTypeCode: string
  storeTypeStr: string
  categoryCode: string
  categoryStr: string
  fileSize: number
  fileSizeStr: string
  sortOrder: number
  downloadCount: number
  fileUrls: string[]
  fileIds?: string[]
  fileList?: { id: string | number; url: string; name?: string; size?: number }[]
  createTime: string
}

export const useMaterial = defineStore('material', {
  state: () => ({}),
  actions: {
    // 分页查询资料
    async getMaterialPage(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/material/page',
          method: 'get',
          params
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 资料详情
    async getMaterialInfo(id: string | number) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/material/info/${id}`,
          method: 'get'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 新增资料
    async createMaterial(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/material/create',
          method: 'post',
          data
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 编辑资料
    async updateMaterial(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/material/update',
          method: 'post',
          data
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 删除资料
    async deleteMaterial(id: string | number) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/material/del/${id}`,
          method: 'post'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 增加下载次数
    async downloadMaterial(id: string | number) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/material/download/${id}`,
          method: 'post'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 上传文件
    async uploadFile(data: FormData) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/file/uploadFile',
          method: 'post',
          data,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 删除文件
    async deleteFile(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/file/delete',
          method: 'get',
          params
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 后端打包下载
    async zipDownloadMaterial(id: string | number) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/material/zipDownload/${id}`,
          method: 'get',
          responseType: 'blob'
        })
          .then((res: any) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 代理下载（前端打包用，后端中转解决跨域）
    async proxyDownload(url: string) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/file/proxyDownload',
          method: 'get',
          params: { url },
          responseType: 'blob'
        })
          .then((res: any) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 获取下一个排序号
    async getNextSortOrder(params: { categoryCode: string }) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/material/nextSortOrder',
          method: 'get',
          params
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 查询资料模板列表（按分类）
    async getMaterialList(params: { categoryCode: string }) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/material/list',
          method: 'get',
          params
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 批量修改资料模板排序
    async batchSortMaterial(data: { id: string; sortOrder: number }[]) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/material/sort',
          method: 'post',
          data
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
})
